import React from 'react'

export const EmptyLayout: React.FC<{ children?: React.ReactNode }> = props => (
  <>{props.children}</>
)
